/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListTemplateChat } from '../../models/api-response-list-template-chat';

export interface ListTemplateChats$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function listTemplateChats(http: HttpClient, rootUrl: string, params: ListTemplateChats$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListTemplateChat>> {
  const rb = new RequestBuilder(rootUrl, listTemplateChats.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListTemplateChat>;
    })
  );
}

listTemplateChats.PATH = '/v1/api/ui/templates-chat/list';
